import { onMounted } from "vue";
import { useRouter } from "vue-router";

export const useNavigation = () => {
    let currentPosition;
    const router = useRouter();

    onMounted(() => {
        currentPosition = router.options.history.state.position;
    });

    return {
        isGoingBackBeforeRouteLeave: () => {
            const pos = router.options.history.state.position;
            return  !pos || pos < currentPosition;
        },
        isGoingForwardBeforeRouteLeave: () => {
            const pos = router.options.history.state.position;
            return  pos > currentPosition;
        },
    }
}
